import { Navigate, Outlet } from "react-router-dom";

export default function AgentRoutes({ isAgent }: { isAgent: boolean }) {
  if (!isAgent) {
    return <Navigate to={process.env.REACT_APP_MANAGEMENT!} replace />;
  }

  return <Outlet />;
}
